import React, { useState } from 'react';

import BaseModal from '../BaseModal';
import ButtonTransparent from '../ui/ButtonTransparent';

import './index.css';

const InventoryPartModal = (props) => {
  const { part } = props;
  const [formValues, setFormValues] = useState(() => {
    if (!part) {
      return {
          bin: '',
          partNumber: '',
          count: '',
      }
    } else {
      return {
        id: part.id,
        bin: part.bin,
        partNumber: part.partNumber,
        count: part.count,    
      }
    }
  });

  const updateFields = (e) => {
    if (e.target.name === 'partNumber' || e.target.name === 'bin') {
      props.removeError();
    }
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value.toUpperCase()
    });
  }

  const submit = (e) => {
    e.preventDefault();
    props.part
      ? props.onSave(formValues, props.part.bin)
      : props.onAdd(formValues);
  }

  const body = (
    <div className="inventory-part-modal">
      <h2 className="inventory-part-modal__title">{part ? 'Edit Part' : 'New Part'}</h2>
      <form className="inventory-part-modal__form" onSubmit={submit} autoComplete="off">
        <div className="inventory-part-modal__form-group">
          <label className="inventory-part-modal__form-label" htmlFor="bin">Bin</label>
          <input className="inventory-part-modal__form-input" id="bin" type="text" value={formValues.bin} name="bin" onChange={updateFields}/>
        </div>
        <div className="inventory-part-modal__form-group">
          <label className="inventory-part-modal__form-label" htmlFor="partNumber">Part Number</label>
          <input className="inventory-part-modal__form-input" id="partNumber" type="text" value={formValues.partNumber} name="partNumber" onChange={updateFields}/>
        </div>
        <div className="inventory-part-modal__form-group">
          <label className="inventory-part-modal__form-label" htmlFor="count">Quantity</label>
          <input className="inventory-part-modal__form-input" id="count" type="text" value={formValues.count} name="count" onChange={updateFields}/>
        </div>
        <div className="inventory-part-modal__form-error">
          {
            props.modalError &&
            <p className="inventory-part-modal__error-text">{props.modalError}</p>
          }
        </div>
        <div className="inventory-part-modal__form-group inventory-part-modal__controls">
          <input 
            type="submit" 
            value={part ? 'Save': 'Add'} 
            className="inventory-part-modal__form-submit btn btn--primary" 
            disabled={
              !formValues.bin ||
              !formValues.partNumber ||
              !formValues.count ||
              props.modalError
            } 
          />
          {part && <ButtonTransparent name="Delete" className="job-details__form-submit btn btn--transparent" onClick={(e) => { e.preventDefault(); props.onDelete(props.part)}}/>}
        </div>
      </form>
    </div>
  )
  return (
    <BaseModal 
      onClose={props.onClose}
      body={body}
    />
  ); 
}

export default InventoryPartModal;